// intlTelInput is NOT imported here — it's lazy-loaded inside initializeIntlTelInput()
// so the 429KB vendor file is excluded from the initial JS bundle.
import createChatbotModule from "./chatbot.mjs";

const AJAX_COUNTRY_CODE_URL = JSON.parse(
	document.getElementById("ajax_country_code_url").textContent,
);
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const AJAX_CONVERSATION_URLS = JSON.parse(
	document.getElementById("ajax_conversation_urls")?.textContent || "{}",
);

export default () => ({
	whatsAppModalOpen: false,
	whatsAppModalLoading: false,
	showMobileMenu: false,
	lastSelectedCountry: null, // To track the last selected country

	// Spread the chatbot module functionality
	...createChatbotModule(AJAX_CONVERSATION_URLS, false),

	async openWhatsAppModal() {
		try {
			dataLayer.push({'event': 'whatsapp_start', 'event_category': 'WhatsApp', 'event_label': 'WhatsApp Start'});
		} catch (error) {
			console.log('Error al enviar evento whatsapp_start a dataLayer:', error);
		}
		
		this.whatsAppModalOpen = true;
		this.whatsAppModalLoading = true;

		try {
			const response = await fetch(
				`${AJAX_COUNTRY_CODE_URL}?timezone=${timezone}`,
			);
			const response_json = await response.json();
			const country_code = response_json.country_code;

			this.initializeIntlTelInput(country_code);
		} catch (error) {
			console.error("Error fetching country code:", error);
		} finally {
			// Ensure reactivity is updated
			this.whatsAppModalLoading = false;
			this.$nextTick(() => {
				console.log("DOM has updated after loading state was changed.");
			});
		}

		// Listen for HTMX events to reinitialize the input after DOM swaps
		document.addEventListener("htmx:afterSwap", (event) => {
			if (event.detail.target && event.detail.target.id === "whatsapp-form") {
				// Reinitialize intl-tel-input on the updated input
				setTimeout(
					// HACK: to avoid the flags to be positioned on top of the input
					() =>
						this.initializeIntlTelInput(
							this.lastSelectedCountry || country_code,
						),
					100,
				);
			}
		});
	},



	async initializeIntlTelInput(initialCountry) {
		const input = document.querySelector("#whatsapp-modal-telephone");

		if (!input) return;

		// Load on-demand: only fires when the user opens the WhatsApp modal,
		// keeping ~430KB of JS+CSS out of the initial bundle.
		// Parcel splits each dynamic import into its own chunk and injects CSS into <head>.
		// The vendor JS is UMD — fall back to the module itself if no ES default export.
		const [iti] = await Promise.all([
			import("intl-tel-input"),
			import("../../vendor/intl-tel-input/intlTelInput.css"),
			import("../../styles/elements/_intl-tel-input.scss"),
		]);
		const intlTelInput = iti.default || iti;

		const contact_iti_instance = intlTelInput(input, {
			initialCountry: initialCountry,
			formatAsYouType: false,
			formatOnDisplay: false,
			separateDialCode: true,
		});

		const updateTelephoneInputs = () => {
			const countryData = contact_iti_instance.getSelectedCountryData();
			this.lastSelectedCountry = countryData.iso2; // Save the selected country
			document.querySelector("#whatsapp-modal-telephone-prefix").value =
				countryData.dialCode;
			document.querySelector("#whatsapp-modal-telephone-country-code").value =
				countryData.iso2;
		};

		// Update hidden inputs on initialization and country change
		updateTelephoneInputs();
		input.addEventListener("countrychange", updateTelephoneInputs);
	},

	openCookiesModal() {
		this.$dispatch('cookies-configure');
	},

});
